import script from "./SearchNoteTypeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchNoteTypeInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchNoteTypeInput.vue?vue&type=style&index=0&id=55b90812&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b90812"]])

export default __exports__